/**
 * List of known extension keys for the goal entity
 */ export var GoalExtensionKeys = /*#__PURE__*/ function(GoalExtensionKeys) {
    /** Color data for the goal */ GoalExtensionKeys["colorData"] = "colorData";
    /** Copilot/AI metadata for the goal */ GoalExtensionKeys["copilot"] = "copilot";
    return GoalExtensionKeys;
}({});
